// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__CEjvS","alertIcon":"ConfirmModal_alertIcon__2m3Zk"};